import RoadMajorLabel from './RoadMajorLabel'
import RoadMinor from './RoadMinor'
import color from './colorThemes'
import config from '../../../config'

const { minZoom, maxZoom } = config.map
const start = minZoom + 2

export default {
  ...RoadMajorLabel,
  filter: RoadMinor.filter,
  id: 'roadMinorLabel',
  type: 'symbol',
  minzoom: start,
  layout: {
    'symbol-placement': 'line',
    'symbol-spacing': 500,
    'text-field': '{name}',
    'text-font': ['FiraSans-Regular'],
    'text-size': {
      stops: [[start, 12], [maxZoom, 22]],
    },
  },
  paint: {
    'text-color': color.roadMinorLabel,
    'text-halo-color': color.halo,
    'text-halo-width': 3,
  },
}
